import {
  beRcsCopyTemplate,
  beRcsDeleteTemplate,
  beRcsGetMessage,
  beRcsGetToken,
} from 'Api/beRcs'
import { beRcsSendAddAgentDeclarationLog } from 'Api/beRcsSend'
import { beRecipientGetDynamicFieldsDefinition } from 'Api/beRecipientApi'
import { beSmsAliasGetListOfSmsAlias } from 'Api/beSmsAlias'
import { beSmsSendGetListSenders } from 'Api/beSmsSend'
import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'
import type {
  beRcsCopyTemplateResponse,
  beRcsGetMessageResponse,
  beRcsGetTokenResponse,
  beRecipientGetDynamicFieldDefinitionResponse,
  beSmsAliasGetListOfSmsAliasResponse,
  beSmsSendGetListSendersResponse,
  SmsAliasItem,
} from 'Pages/RcsList/types'

export const GetAgileToken = async (): Promise<beRcsGetTokenResponse> => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beRcsGetToken(idList)

  return result
}

export const getListAllSmsAlias =
  async (): Promise<beSmsAliasGetListOfSmsAliasResponse> => {
    const result = await beSmsAliasGetListOfSmsAlias({
      pageNum: 1,
      pageSize: 0,
      status: 3,
      orderBy: 'RequestDate',
      orderDescending: true,
    })

    return result
  }

export const getAllListSenders =
  async (): Promise<beSmsSendGetListSendersResponse> => {
    const result = await beSmsSendGetListSenders(
      {
        pageNum: 1,
        pageSize: 0,
        OrderBy: 'NumericSender',
        orderAsc: true,
      },
      {
        NumericSender: '',
        Status: 'Confirmed',
      },
    )

    return result
  }

export const getDynamicFieldsDefinition = async (): Promise<
  Array<beRecipientGetDynamicFieldDefinitionResponse>
> => {
  const result = await beRecipientGetDynamicFieldsDefinition({
    isdynamic: true,
  })

  return result as beRecipientGetDynamicFieldDefinitionResponse[]
}

export const copyTemplate = async (
  externalId: number,
): Promise<beRcsCopyTemplateResponse> => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beRcsCopyTemplate(idList, externalId)

  return result
}

export const deleteTemplate = async (externalId: number): Promise<void> => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beRcsDeleteTemplate(idList, externalId)

  return result
}

export const getMessage = async (
  idMessage: number,
): Promise<beRcsGetMessageResponse> => {
  const result = await beRcsGetMessage(idMessage)

  return result
}
